/* tslint:disable */

declare var Object: any;
export interface MemberInterface {
  "realm"?: string;
  "username"?: string;
  "password": string;
  "emailverified"?: number;
  "verificationtoken"?: string;
  "empid"?: string;
  "companyid"?: string;
  "companycode"?: string;
  "id"?: number;
  "email": string;
  "emailVerified"?: boolean;
  "verificationToken"?: string;
  accessTokens?: any[];
}

export class Member implements MemberInterface {
  "realm": string;
  "username": string;
  "password": string;
  "emailverified": number;
  "verificationtoken": string;
  "empid": string;
  "companyid": string;
  "companycode": string;
  "id": number;
  "email": string;
  "emailVerified": boolean;
  "verificationToken": string;
  accessTokens: any[];
  constructor(data?: MemberInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Member`.
   */
  public static getModelName() {
    return "Member";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Member for dynamic purposes.
  **/
  public static factory(data: MemberInterface): Member{
    return new Member(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Member',
      plural: 'Members',
      properties: {
        "realm": {
          name: 'realm',
          type: 'string'
        },
        "username": {
          name: 'username',
          type: 'string'
        },
        "password": {
          name: 'password',
          type: 'string'
        },
        "emailverified": {
          name: 'emailverified',
          type: 'number'
        },
        "verificationtoken": {
          name: 'verificationtoken',
          type: 'string'
        },
        "empid": {
          name: 'empid',
          type: 'string'
        },
        "companyid": {
          name: 'companyid',
          type: 'string'
        },
        "companycode": {
          name: 'companycode',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "email": {
          name: 'email',
          type: 'string'
        },
        "emailVerified": {
          name: 'emailVerified',
          type: 'boolean'
        },
        "verificationToken": {
          name: 'verificationToken',
          type: 'string'
        },
      },
      relations: {
        accessTokens: {
          name: 'accessTokens',
          type: 'any[]',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk-budget/models/Member.ts